import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { BookingAreaEditor } from '@/components/operator/booking-area-editor'
import { OperatorWorkspaceRouteGate } from '@/components/operator/operator-workspace-route-gate'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/service-area')({
  component: BookingAreaPage,
  staticData: {
    breadcrumbs: [{ label: 'Service Area' }],
  } satisfies RouteStaticData,
})

function BookingAreaPage() {
  const { configuration, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <OperatorWorkspaceRouteGate
        configuration={configuration}
        isLoading={isLoading}
        error={error}
        onRetry={refreshAll}
        loadingCopy="Loading service area…"
        resourceLabel="service area"
        noOperatorTitle="Set up your business before configuring service area."
        noOperatorDescription="Finish setup first so travel limits and pricing rules can be saved for your operator profile."
      >
        <BookingAreaEditor configuration={configuration} onSaved={refreshAll} />
      </OperatorWorkspaceRouteGate>
    </WorkspaceRouteShell>
  )
}
